import { createAsyncThunk } from '@reduxjs/toolkit'
import { managementsData } from '@assets/mockdata'
import { Management, UpdateManagementThunkParams } from '@dataTypes/index'

export const fetchAllManagements = createAsyncThunk(
  'managements/fetchAllManagements',
  async () => {
    return managementsData
  },
)

export const addManagement = createAsyncThunk(
  'managements/addManagement',
  async (body: Management) => {
    return body
  },
)

export const updateManagement = createAsyncThunk(
  'managements/updateManagement',
  async (params: UpdateManagementThunkParams) => {
    const { id, body } = params
    return { id, body }
  },
)

export const removeManagement = createAsyncThunk(
  'managements/removeManagement',
  async (index: string) => {
    return index
  },
)
